"use client";

import { useCallback, useRef } from "react";

const CHARS =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

export function useTextScramble() {
  const rafRef = useRef<number | null>(null);

  const scramble = useCallback(
    (
      el: HTMLElement | null,
      target: string,
      duration = 600,
      onComplete?: () => void
    ) => {
      if (!el) return;
      const element = el;
      if (rafRef.current) cancelAnimationFrame(rafRef.current);

      const len = target.length;
      let start: number | null = null;

      function step(ts: number) {
        if (!start) start = ts;
        const progress = Math.min((ts - start) / duration, 1);
        let result = "";
        for (let i = 0; i < len; i++) {
          if (i / len < progress) {
            result += target[i];
          } else {
            result += CHARS[Math.floor(Math.random() * CHARS.length)];
          }
        }
        element.textContent = result;
        if (progress < 1) {
          rafRef.current = requestAnimationFrame(step);
        } else {
          onComplete?.();
        }
      }

      rafRef.current = requestAnimationFrame(step);
    },
    []
  );

  return scramble;
}
